export interface BankAccount {
  id: string;
  bank_name: string;
  display_name: string;
  invoice_name: string;
  invoice_format: string;
  gstin?: string | null;
  logo?: string | null;
  address?: string | null;
  phone?: string | null;
  email?: string | null;
  account_name: string;
  branch_name?: string | null;
  account_number: string;
  ifsc_code: string;
  created_at?: string;
  updated_at?: string;
}

export interface BankAccountSequence {
  fy_code: string;
  last_issued: number;
  next: number;
}

export interface BankAccountListResponse {
  success: boolean;
  message: string;
  data: {
    bank_accounts: BankAccount[];
    total: number;
    pageCount: number;
  };
}

// ── Invoice-ID format helpers (mirror ph_server/src/utils/invoiceFormat.js) ──

export const DEFAULT_INVOICE_FORMAT = 'INV/PM/{{financialYear}}/{{autoId}}';

export const INVOICE_FORMAT_PLACEHOLDERS = ['financialYear', 'autoId', 'year', 'month'];

const PLACEHOLDER_REGEX = /\{\{\s*(\w+)\s*\}\}/g;

/** Returns a user-facing error message, or null when the format is valid. */
export function invoiceFormatError(format: string): string | null {
  if (!format || !format.trim()) return 'Invoice format is required';
  const tokens = Array.from(format.matchAll(PLACEHOLDER_REGEX)).map((m) => m[1]);
  const unknown = tokens.find((t) => !INVOICE_FORMAT_PLACEHOLDERS.includes(t));
  if (unknown) return `Unknown placeholder "${unknown}" — allowed: ${INVOICE_FORMAT_PLACEHOLDERS.join(', ')}`;
  if (!tokens.includes('autoId')) return 'Format must include the {{autoId}} placeholder';
  return null;
}

/** Renders the format with sample values (current FY, sequence 1). */
export function previewInvoiceId(format: string): string {
  const now = new Date();
  const fyStart = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  const values: Record<string, string> = {
    financialYear: `${String(fyStart).slice(-2)}-${String(fyStart + 1).slice(-2)}`,
    autoId: '1',
    year: String(now.getFullYear()),
    month: String(now.getMonth() + 1).padStart(2, '0'),
  };
  return format.replace(PLACEHOLDER_REGEX, (_, key) => values[key] ?? '');
}
